import {CodePipeline,} from '../types';
import {PlatformPropertyCard} from "@flexinet/ui-components";
import {Stack, Table, Title} from '@mantine/core';


export const Profile = ({record}: { record: CodePipeline }) => {

    const properties = [
        {
            label: 'Name',
            value: record.name as string,
            span: 12,
        }, {
            label: 'ARN',
            value: record.arn || 'n/a',
            span: 12,
        }, {
            label: 'Version',
            value: record.version?.toString() || 'n/a',
            span: 12,
        }, {
            label: 'CloudFormation Stack',
            value: record.cloudFormationStackName || 'n/a',
            span: 12,
        }, {
            label: 'Last Execution Status',
            value: record.lastExecutionStatus || 'n/a',
            span: 12,
        }];

    const properties2 = [
        {
            label: 'Last Execution Time',
            value: record.lastExecutionTime as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 12,
        }];

    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={properties}/>

            {record.stages && record.stages.length > 0 && (
                <Stack gap={'sm'}>
                    <Title order={5}>Pipeline Stages</Title>
                    <Table striped highlightOnHover withTableBorder>
                        <Table.Thead>
                            <Table.Tr>
                                <Table.Th>Stage</Table.Th>
                                <Table.Th>Actions</Table.Th>
                            </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody>
                            {record.stages.map((stage, index) => (
                                <Table.Tr key={index}>
                                    <Table.Td>{stage.name}</Table.Td>
                                    <Table.Td>
                                        {stage.actions?.map(a => `${a.name} (${a.provider})`).join(', ') || 'n/a'}
                                    </Table.Td>
                                </Table.Tr>
                            ))}
                        </Table.Tbody>
                    </Table>
                </Stack>
            )}

            <PlatformPropertyCard properties={properties2}/>
        </Stack>
    );


};
